import InheritedTemplateActivityModal from './inherited-template-activity-modal-container'
export default InheritedTemplateActivityModal
